import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import StoreAutoComplete from './StoreAutoComplete'

import Leads from '../../../stores/leads'

@inject('websites')
@observer
export default class AutoCompleteLeads extends Component {
  leads = new Leads({ website: this.props.websites.current })

  fetchSuggestions = value => {
    return this.leads.search(value).then(() => [...this.leads])
  }

  renderSuggestion = suggestion => (
    <div>
      <strong>{suggestion.first_name} {suggestion.last_name}</strong>
      <br />
      <small>({suggestion.email})</small>
    </div>
  )

  getValue = suggestion => suggestion.email

  render() {
    const { name, onCreateNew, onSelect, selected, clearAfterSelect, exclude } = this.props
    return (
      <StoreAutoComplete
        store={this.leads}
        getValue={this.getValue}
        renderSuggestion={this.renderSuggestion}
        fetchSuggestions={this.fetchSuggestions}
        name={name}
        exclude={exclude}
        selected={selected}
        onSelect={onSelect}
        onCreateNew={onCreateNew}
        createNewType="Lead"
        placeholder="Select a Lead"
        clearAfterSelect={clearAfterSelect} />
    )
  }
}



// WEBPACK FOOTER //
// client/components/util/auto_complete/Leads.js